enum NameLabelColor {
  Blue = 'blue',
  Pink = 'pink',
  Green = 'green',
  Black = 'black',
}

export default class SpeechTextRenderOptions {
  constructor(
    public speed?: number,
    public overrideCharacterName?: boolean | null,
    public characterName?: string | null,
    public characterNameLabelColor?: NameLabelColor | null,
  ) {}
}
